// src/components/CategoryHero.js
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { getHomepageCategoryHero } from "../services/homepage.api";

function CategoryHero() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [hero, setHero] = useState(null);

  useEffect(() => {
    getHomepageCategoryHero().then(setHero).catch(() => {});
  }, []);

  if (!hero) return null;

  return (
    <button
      onClick={() =>
      navigate(`/products?category=${hero.link_target}`, {
  state: { from: "home" },
})
      }
      className="w-full mt-2 mb-1 relative overflow-hidden group"
    >
      <img
        src={hero.image_url}
        loading="lazy"
        decoding="async"
        className="w-full h-60 md:h-[480px] object-cover"
      />

      <div className="absolute inset-0 bg-black/50"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
        <p className="text-xl md:text-4xl font-light">
          {lang === "EN" ? hero.title_en : hero.title_ar}
        </p>

        <p className="mt-3 text-sm md:text-lg opacity-80">
          {lang === "EN" ? hero.subtitle_en : hero.subtitle_ar}
        </p>

        <span className="mt-5 underline text-sm">
          {lang === "EN" ? "SHOP NOW" : "تسوقي الآن"}
        </span>
      </div>
    </button>
  );
}

export default CategoryHero;

